import { z } from 'zod'
import { orderArchiveStatusSchema, rentalOrderBusinessStatusSchema } from '@super-mega/server/contracts/order'
import { DEFAULT_PAGE_SEARCH } from '@/const/list.ts'
import {
  createdAtSearchShape,
  createdAtSortSearchShape,
  creatorMemberSearchShape,
  toSearchArray
} from '@/utils/list-query.ts'
import { toBusinessStatusSearch } from './utils/order-list-search.ts'

const id = z.coerce.number().int().positive().optional().catch(undefined)

const multiId = z.preprocess(toSearchArray, z.array(z.coerce.number().int().positive()).min(1).max(100).optional())
const multiStatus = z.preprocess(
  toBusinessStatusSearch,
  z.array(rentalOrderBusinessStatusSchema).min(1).max(20).optional()
)
export const rentalListSearchSchema = z.object({
  ...createdAtSearchShape,
  ...createdAtSortSearchShape,
  ...creatorMemberSearchShape,
  current: z.coerce.number().int().positive().catch(1),
  pageSize: z.coerce.number().int().min(1).max(100).catch(20),
  id,
  keyword: z.string().trim().max(255).optional().catch(undefined),
  note: z.string().trim().max(255).optional().catch(undefined),
  status: multiStatus.catch(undefined),
  archiveStatus: orderArchiveStatusSchema.catch('unarchived'),
  businessId: multiId.catch(undefined),
  customerId: multiId.catch(undefined),
  salespersonId: multiId.catch(undefined),
  subjectId: multiId.catch(undefined),
  subjectAssociation: z.enum(['linked', 'unlinked']).optional().catch(undefined),
  orderGroupId: id,
  siteId: multiId.catch(undefined),
  roomId: id
})
export type RentalListSearch = z.infer<typeof rentalListSearchSchema>
export const DEFAULT_RENTAL_SEARCH = { ...DEFAULT_PAGE_SEARCH, archiveStatus: 'unarchived' as const }

export { RENT_UNITS, RENTAL_STATUS } from '@/features/order/const/rental-list-search.ts'

// 新建页的返回位置属于历史条目状态，不属于新建表单的查询参数。
declare module '@tanstack/react-router' {
  interface HistoryState {
    rentalListReturnSearch?: RentalListSearch
  }
}
